.pn-progress-indicator {
  display: flex;
  padding: 2.8em 1em 0;
}
